module.exports = __webpack_public_path__ + "static/assets/14ca42a8fe58eac304681f850e8de3f2.gif";